


























import { Component, Vue } from 'vue-property-decorator';
import { windowHelper } from '@tencent/ppd-base-libs';
import { isShowActBanner, isGoodDeedDay } from '@/business/helper';
import { MultiJumpContainer, MultiJumpInfo } from '@tencent/wphk-components-multi-jump-container';

@Component({
  components: {
    MultiJumpContainer,
  },
})
export default class PageTab extends Vue {
    jumpInfo: MultiJumpInfo = {
      appid: 'wxff244f6b82a094d2', // 跳转小程序
      username: 'gh_713a18875797', // 跳转小程序
      path: 'pages/activity/index/main?aid=ca_16FPT8ORZSCAV',
    }

    get isShowGoodDeed() {
      return isGoodDeedDay();
    }

    get isShowTab() {
      return isShowActBanner();
    }

    get btnText() {
      return '慈善';
    }

    goGoodDeedDay() {
      windowHelper.redirect('https://prom.wechatpay.com.hk/good-deed-day/index.shtml?ADTAG=charityPageTab', 0);
    }
}
